// extracted by mini-css-extract-plugin
export default {"grille":"Rapports_grille__Qo1cl","titre":"Rapports_titre__oSj+D"};